export default __webpack_public_path__ + "static/media/add-message.c778518b.svg";